import { render } from "./ForbiddenPage.vue?vue&type=template&id=426d4bd7&scoped=true&ts=true"
import script from "./ForbiddenPage.vue?vue&type=script&lang=ts"
export * from "./ForbiddenPage.vue?vue&type=script&lang=ts"

import "./ForbiddenPage.vue?vue&type=style&index=0&id=426d4bd7&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426d4bd7"]])

export default __exports__